import { EventEmitter, Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ToastService {
  public onToastCall = new EventEmitter<string>();

  constructor() {}

  callToast(msg: string) {
    this.onToastCall.emit(msg);
  }
}
